import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import browserUtils from './slices/browserUtils';
import data from './slices/data';
import thumbslider from './slices/thumbslider';

const reducer = combineReducers({
  browserUtils: browserUtils.reducer,
  data: data.reducer,
  thumbslider: thumbslider.reducer,
});

const store = configureStore({
  reducer,
});

export default store;
